import * as React from "react";
import { FunctionComponent } from "react";
import { countryList } from "../../../ts/constants/form-values";
import { fieldError } from "./address-variant-fields";

interface IProps {
	register: any;
	errors: any;
	watch: any;
	/** Feldnamen-Präfix: `""` im Kundenpfad, `"billing."` in der Gastbestellung. */
	namePrefix?: string;
	/** Land der bearbeiteten Adresse, solange das Feld selbst noch keinen Wert liefert. */
	fallbackCountry?: string;
	createApiError: (key: string) => any;
}

/**
 * VAT-Feld, sichtbar und pflichtig nur für Länder mit `vatNeeded` in
 * [form-values.ts](../../../ts/constants/form-values.ts). Gemeinsam genutzt aus demselben Grund
 * wie die Adressart: es ist eines der wenigen Adressfelder mit Bedingungslogik.
 */
export const VatField: FunctionComponent<IProps> = (props: IProps) => {
	const prefix = props.namePrefix ?? "";
	const selectedCountry = props.watch(`${prefix}country`) ?? props.fallbackCountry;
	const vatNeeded = countryList.find((country) => country.value === selectedCountry)?.vatNeeded;
	const apiError = props.createApiError("VatNo");

	if (!vatNeeded) {
		// Serverseitiger VAT-Fehler bei ausgeblendetem Feld: sonst wäre die Meldung unsichtbar und
		// das Formular ließe sich nicht mehr abschicken. Gleiches Vorgehen wie in LeitwegIdField.
		return apiError ? (
			<div className="form-group row">
				<div className="col-sm-4 col-form-label">VAT</div>
				<div className="col-sm-8">{apiError}</div>
			</div>
		) : null;
	}

	return (
		<div className="form-group row">
			<label className="col-sm-4 col-form-label">
				VAT <span className="mandatory">*</span>
			</label>
			<div className="col-sm-8">
				<input
					type="text"
					name={`${prefix}vatNo`}
					className="form-control"
					placeholder="VAT"
					maxLength={35}
					ref={props.register({ required: true })}
				/>
				{fieldError(props.errors, `${prefix}vatNo`) && (
					<div className="form-error">Bitte geben Sie die VAT ein.</div>
				)}
				{apiError}
			</div>
		</div>
	);
};
